import React, { useState } from "react";
import { Input } from "antd";
import { ReactComponent as Micro } from "./../../assets/icons/micro.svg";
import { useDispatch } from "react-redux";
import { textChange } from "../../store/slices/textSlice";

const Searchbar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const dispatch = useDispatch();

  const filteredOrders = (e) => {
    dispatch(textChange(e.target.value));
  };

  return (
    <div className="w-full">
      <Input
        className={`w-full ml-3 lg:ml-1 h-5 rounded-md transition-colors ${
          isHovered || isFocused ? "border-primaryBlue" : "border-gray-300"
        }`}
        placeholder="Search Anything..."
        prefix={<Micro />}
        onPressEnter={filteredOrders}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  );
};

export default Searchbar;
